// import { handlingGoldPriceCreated } from "./goldPriceCreated";
import { handleGoldPriceIsActiveUpdated } from "./handleGoldPriceIsActiveUpdated";
import { handleGoldPriceCreationPatch } from "./handleGoldPricePatch";
// import { handlePriceCreated } from "./handlePriceCreated";
import { handleStepPriceUpdated } from "./handleStepPriceUpdated";
import { handleParentQDDeleted } from "./parentQuantityDefinitionPatches/parentQuantityDefinitionDeleted";
import { handleParentQDUpdated } from "./parentQuantityDefinitionPatches/parentQuantityDefinitionUpdated";
import { createQuantityDefintionCategory } from "./quantityDefinitionCategoryPatches/quantityDefinitionCategoryCreated";
import { deleteQuantityDefintionCategory } from "./quantityDefinitionCategoryPatches/quantityDefinitionCategoryDeleted";
import { updateQuantityDefintionCategory } from "./quantityDefinitionCategoryPatches/quantityDefinitionCategoryUpdated";
import { handleQuantityDefintionCreated } from "./quantityDefinitionPatches/quantityDefinitionCreated";
import { handleQuantityDefintionDeleted } from "./quantityDefinitionPatches/quantityDefinitionDeleted";
import { handleQuantityDefintionUpdated } from "./quantityDefinitionPatches/quantityDefinitionUpdated";

export const patchRouter = {
    // PRICE_CREATED: handlePriceCreated,
    PRICE_CREATED: handleGoldPriceCreationPatch,
    STEP_UPDATED: handleStepPriceUpdated,
    GOLD_PRICE_IS_ACTIVE_UPDATED: handleGoldPriceIsActiveUpdated,
    PQD_UPDATED: handleParentQDUpdated,
    PQD_DELETED: handleParentQDDeleted,
    QUANTITY_DEFINITION_CATEGORY_CREATED: createQuantityDefintionCategory,
    QUANTITY_DEFINITION_CATEGORY_UPDATED: updateQuantityDefintionCategory,
    QUANTITY_DEFINITION_CATEGORY_DELETED: deleteQuantityDefintionCategory,
    QUANTITY_DEFINITION_UPDATED: handleQuantityDefintionUpdated,
    QUANTITY_DEFINITION_CREATED: handleQuantityDefintionCreated,
    QUANTITY_DEFINITION_DELETED: handleQuantityDefintionDeleted,
};